/* ================================================== */
/* ANGULARJS > Modules
/* ================================================== */

var app = angular
	.module('formApp', ['ngSanitize', 'ngAnimate', 'ngAria', 'ngMessages'])
	.config(['$interpolateProvider', '$httpProvider', function($interpolateProvider, $httpProvider) {
		$interpolateProvider.startSymbol('{(').endSymbol(')}');

		$httpProvider.defaults.transformRequest = function(data){
			if (data === undefined) {
				return data;
			}
			return $.param(data);
		}
	}
]);